// extracted by mini-css-extract-plugin
module.exports = {"loading-overlay":"_1R9o48I0GH_6HR0iFAzqUZ","loading-dialog":"_2JnDqkwbBIr37cuFgxdg4U"};